import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { browserHistory } from 'react-router'
import { syncHistory } from 'react-router-redux'
import rootReducer from 'services/rootReducer'
import devToolsMiddleware, { listenForReplays } from 'application/middleware/devToolsExtension'
import promiseMiddleware from 'application/middleware/promiseMiddleware'
import localCacheMiddleware from 'application/middleware/localCacheMiddleware'
import createLogger from 'redux-logger'
import { notificationMiddleware } from 'application/middleware/notificationMiddleware'
import unauthorizedMiddleware from 'application/middleware/unauthorizedMiddleware'
import actionListenerStoreEnhancer from './actionListenerStoreEnhancer'

const reduxRouterMiddleware = syncHistory(browserHistory) // sync dispatched route actions to the history
const loggerMiddleware = createLogger({
  collapsed: true,
  predicate: (getState, action) => {
    if (!action || !action.type) { return }
    if (action.type.match(/redux-form/)) { return false }
    if (action.type.match(/@@route/)) { return false }
    return true
  },
})

export default function configureStore (initialState, apis = {}) {

  const middleware = [
    reduxRouterMiddleware,
    thunkMiddleware.withExtraArgument(apis),
    localCacheMiddleware(initialState.bootup.localCacheNonce),
    promiseMiddleware,
    loggerMiddleware,
    unauthorizedMiddleware,
    notificationMiddleware,
  ]

  const store = createStore(
    combineReducers(rootReducer),
    initialState,
    compose(
      applyMiddleware(...middleware),
      actionListenerStoreEnhancer,
      devToolsMiddleware()
    )
  )

  listenForReplays(reduxRouterMiddleware, store) // required for replaying actions from devtools to work

  return store
}



// WEBPACK FOOTER //
// ./src/application/store/configureStore.dev.js